import { Component, Prop, Event, EventEmitter, Method } from '@stencil/core';

export type RouterEventDetail = {
  url: string | undefined | null;
  event: Event | undefined | null;
};

@Component({
  tag: 'sy-router',
})
export class Router {
  /**
   * The root path to use when matching URLs. By default, this is set to "/", but you can specify
   * an alternate prefix for all URL paths.
   */
  @Prop() root = '/';

  /**
   * Emitted when the route had changed
   */
  @Event() syRouterDidChange: EventEmitter<RouterEventDetail>;

  /**
   * Navigate to the specified URL.
   */
  @Method()
  async push(url: string, event: any): Promise<boolean> {
    if (url.startsWith('.')) {
      url = new URL(url, window.location.href).pathname;
    } else if (this.root !== '/' && this.root !== null) {
      url = new URL(url, this.root).pathname;
    }

    this.syRouterDidChange.emit({ url, event });

    return true;
  }
}
